<template>
  <section class='lt-fyf-question'>
    <h2
      class='lt-fyf-question_title'
      tabindex="-1"
      aria-live="polite"
      ref="question"
      aria-atomic="true"
    >
      {{ title }}
    </h2>
    <div class='lt-fyf-question_answers'>
      <slot />
    </div>
  </section>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  props: {
    title: {
      type: String,
      default: '~~~~~~~',
    },
  },
  methods: {
    ...mapMutations([
      'goToPreviousPage',
    ]),
  },
  mounted() {
    this.$refs.question.focus(); // for accessibility
  }
};
</script>

<style lang='scss'>

$mobile-bp: 650px;

.lt-fyf-question {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;

}

h2.lt-fyf-question_title {
  background: $main-background;
  color: $main-color;
  font-size: 2rem;
  margin: .5rem 0 1rem;
  padding: 0.75rem .375rem;
  text-align: center;
  border-radius: 3px;
  box-shadow: $q-a-shadow;
  outline: 0;
  @include breakpoint-portrait {
    @media (max-width: $mobile-bp) {
      font-size: 1.2rem;
    }
  }
}

.lt-fyf-question_answers {
  display: flex;
  justify-content: space-between;
  margin: -0.375rem -0.750rem; /* Remove margin between questions from sides (mobile & desktop) */

  @include breakpoint-portrait {
    flex-direction: column;
    flex: 1;
    justify-content: flex-start;
  }
}

</style>
